export default __webpack_public_path__ + "static/media/raise-hands.c62cd4b2.svg";